import { SpriteTextItemInterface } from '@/types/newTypes'
import React from 'react'

const SecurityAndPrivacyBrand = () => {
  const items: SpriteTextItemInterface[] = [
    {
      vectorId: '#guard-mini',
      text: '100% Private & Secure',
    },
    {
      vectorId: '#lock',
      text: 'Advanced Encryption for Photo Safety',
    },
  ]

  return (
    <section className="relative grid justify-center mb-[11px] grid-cols-2 gap-4 ">
      {items.map((item, index) => (
        <div
          key={index}
          className="p-3 flex justify-center items-center text-center relative before:absolute before:content-[''] before:-left-px before:-right-px before:-top-px before:-bottom-px before:z-[-1] bg-card before:bg-borgerGradient before:rounded-2xl rounded-2xl"
        >
          {/* <svg width={24} height={24}>
            <use href={`/svg/sprite.svg${item.vectorId}`}></use>
          </svg> */}
          <p className="text-[12px] relative z-10 leading-[1.34] text-center">{item.text}</p>
        </div>
      ))}
    </section>
  )
}

export default SecurityAndPrivacyBrand
